const questionType = {
  MultiChoice: 'MultipleChoice',
  ShortAnswer: 'ShortAnswer',
  NumericAnswer: 'NumericAnswer'
};

export default questionType;



// WEBPACK FOOTER //
// ./src/constants/question-type.js